import intl from "react-intl-universal";
import {
  TbBuildingBank,
  TbDownload,
  TbPlayerPlay,
  TbRefresh,
  TbUsers,
} from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { BAAS_ACCOUNTS_PATH } from "../../constants";

export const BaasTransactionsQuickActions = ({
  isHml = false,
  onSimulate,
  onExport,
  onRefresh,
}) => {
  const actions = [
    ...(isHml
      ? [
          {
            id: "simulate",
            labelKey: "baas.transactions.quickActions.simulate",
            icon: TbPlayerPlay,
            onClick: onSimulate,
          },
        ]
      : []),
    {
      id: "export",
      labelKey: "baas.transactions.quickActions.export",
      icon: TbDownload,
      onClick: onExport,
    },
    {
      id: "refresh",
      labelKey: "baas.transactions.quickActions.refresh",
      icon: TbRefresh,
      onClick: onRefresh,
    },
    {
      id: "accounts",
      labelKey: "baas.transactions.quickActions.accounts",
      icon: TbBuildingBank,
      to: BAAS_ACCOUNTS_PATH,
    },
    {
      id: "entities",
      labelKey: "baas.transactions.quickActions.entities",
      icon: TbUsers,
      to: "/baas/entidades",
    },
  ];

  return (
    <section className="min-w-0 w-full">
      <p className="dashboard-section-label mb-3">
        {intl.get("baas.transactions.quickActionsSection")}
      </p>
      <div className="shortcut-scroll-row">
        {actions.map(({ id, labelKey, icon, onClick, to }) => (
          <ShortcutCard
            key={id}
            icon={icon}
            label={intl.get(labelKey)}
            onClick={onClick}
            to={to}
          />
        ))}
      </div>
    </section>
  );
};
